import { render, staticRenderFns } from "./ChangeStructureInput.vue?vue&type=template&id=e704ce44&"
import script from "./ChangeStructureInput.vue?vue&type=script&lang=js&"
export * from "./ChangeStructureInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports